import { normalizeCoordinate, getBoundaryCoordinates } from '@ha/algolia';
import { RadiusValue, radiusValueToMeters } from 'ha/types/SearchFilters';

import { Bounds } from '../../reducer/Types';
import { ReqParams } from './types';

interface MapParams {
  latitude: number;
  longitude: number;
  radius: number;
}

export default (reqParams: Partial<ReqParams & Bounds>, mapParams: MapParams) =>
  reqParams.topLat &&
  reqParams.rightLng &&
  reqParams.bottomLat &&
  reqParams.leftLng
    ? [
        [
          normalizeCoordinate(reqParams.topLat),
          normalizeCoordinate(reqParams.rightLng),
          normalizeCoordinate(reqParams.bottomLat),
          normalizeCoordinate(reqParams.leftLng),
        ],
      ]
    : [
        getBoundaryCoordinates(
          mapParams.latitude,
          mapParams.longitude,
          (reqParams.radius && reqParams.radius !== RadiusValue.DEFAULT
            ? radiusValueToMeters(reqParams.radius)
            : mapParams.radius) / 1000,
        ),
      ];
